export default {
    messageTitle: '消息中心',
    messageCenterClose: '消息中心已關閉，無法接受消息推送',
    openNotification: '去開啟',
    noData: '暫無消息',
    loadingFailed: '載入失敗',
    systemNotion: '系統公告',
    businessNotion: '業務提醒',
    activityNotion: '活動提醒',
    serviceNotion: '聯繫客服',
    toServeYou: '很高興為您服務',
    viewDetails: '查看詳情',
    productName: '產品名稱：',
    amount: '訂單金額：',
    filledAmount: '確認金額：',
    parValue: '票面面额：',
    filledQuantity: '確認份額：',
    filledPrice: '成交凈值：',
    confirmedPrice: '確認價格：',
    accruedInterest: '應付利息：',
    informationTitle: '復星財富早知道',
}
